import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { AuthenticationService } from '../authentication-service/authentication.service';

/**
 * Guard that only allows unauthenticated users to access the route.
 * If the user is already logged in, they are redirected to the home page.
 */
export const UnauthenticatedGuard = () => {
  const authenticationService: AuthenticationService = inject(AuthenticationService);
  const router = inject(Router);
  const isLoggedIn: boolean = authenticationService.isAuthenticatedQuickCheck();

  if (isLoggedIn) {
    // User is already authenticated, redirect to home
    return router.createUrlTree(['/']);
  }

  // User is not authenticated, allow access to welcome page
  return true;
};
